import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip, Grid, Typography, Divider, Button } from '@material-ui/core';
import LinkRoundedIcon from '@material-ui/icons/LinkRounded';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import { trim } from 'lodash';
import moment from 'moment';
import RemoveCircleOutlineRoundedIcon from '@material-ui/icons/RemoveCircleOutlineRounded';
import Swal from 'sweetalert2';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    border: '1px solid #eee',
    borderRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  mainInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  name: {
    fontSize: '1.2rem',
  },
  qrcode: {
    color: '#979797',
  },
  chips: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}));

const BonusProductQRCodeGroupProductCard = (props) => {
  const classes = useStyles();
  const { groupProduct, isLoading, removeGroup } = props;

  const handleClickRemoveGroup = () => {
    Swal.fire({
      title: '確定要將該 QRCODE 移出打包？',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((rs) => {
      if (rs.value) {
        removeGroup(groupProduct.qRCodeValue);
      }
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.name}>{groupProduct.bonusProductInfo.name}</div>

      <div className={classes.mainInfo}>
        <div className={classes.qrcode}>{groupProduct.qRCodeValue}</div>

        <div className={classes.chips}>
          <Chip
            variant={
              trim(groupProduct.linkDate) !== '' ? 'default' : 'outlined'
            }
            size="small"
            icon={<LinkRoundedIcon />}
            color={trim(groupProduct.linkDate) !== '' ? 'primary' : 'default'}
            label="歸戶"
          />

          <Chip
            variant={trim(groupProduct.useDate) !== '' ? 'default' : 'outlined'}
            size="small"
            icon={<CheckBoxRoundedIcon />}
            color={trim(groupProduct.useDate) !== '' ? 'primary' : 'default'}
            label="使用"
          />
        </div>
      </div>
      <Divider />
      <div>
        <Grid
          container
          direction="row"
          justifycontent="space-around"
          alignItems="stretch"
          spacing={2}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              歸戶會員
            </Typography>
            <Typography variant="h6">
              {groupProduct.customerInfo
                ? groupProduct.customerInfo.realName
                : ''}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              歸戶時間
            </Typography>
            <Typography variant="caption">
              {groupProduct.linkDate
                ? moment(groupProduct.linkDate).format('YYYY-MM-DD HH:mm:ss')
                : ''}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              歸戶員工
            </Typography>
            <Typography variant="h6">
              {groupProduct.linkStaffInfo
                ? groupProduct.linkStaffInfo.realName
                : ''}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              使用會員
            </Typography>
            <Typography variant="h6">
              {groupProduct.useUserInfo
                ? groupProduct.useUserInfo.realName
                : ''}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              使用時間
            </Typography>
            <Typography variant="caption">
              {groupProduct.useDate
                ? moment(groupProduct.useDate).format('YYYY-MM-DD HH:mm:ss')
                : ''}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              使用員工
            </Typography>
            <Typography variant="h6">
              {groupProduct.useStaffInfo
                ? groupProduct.useStaffInfo.realName
                : ''}
            </Typography>
          </Grid>
        </Grid>
      </div>

      <div>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<RemoveCircleOutlineRoundedIcon />}
          fullWidth
          size="small"
          onClick={handleClickRemoveGroup}
          disabled={isLoading}>
          移出打包
        </Button>
      </div>
    </div>
  );
};

export default BonusProductQRCodeGroupProductCard;
